import { faker } from '@faker-js/faker/locale/en'
import { IReleaseNote } from './index'
import { MockFn, referenceDate } from '../../mock'
import { CountryCode } from '@carsys/enums/country-code'
import { GmsSystemType } from '../enums'

export const mockReleaseNote: MockFn<IReleaseNote> = (extend?) => ({
  UUID: faker.datatype.uuid(),
  GmsSystemType: GmsSystemType.Web,
  IsPublished: true,
  PublishDate: faker.date.past(50, referenceDate).toISOString(),
  URLs: [
    {
      Country: CountryCode.NL,
      URL: faker.internet.url()
    },
    {
      Country: CountryCode.GB,
      URL: faker.internet.url()
    }
  ],
  CreatedAt: faker.date.past(50, referenceDate).toISOString(),
  UpdatedAt: faker.date.past(50, referenceDate).toISOString(),
  ...extend
})

export const emptyReleaseNote: MockFn<IReleaseNote> = (extend?) => ({
  UUID: '',
  GmsSystemType: GmsSystemType.Web,
  IsPublished: false,
  PublishDate: '',
  URLs: [],
  CreatedAt: '',
  UpdatedAt: '',
  ...extend
})
